export const FIELD_TYPES = {
  TEXT: "text",
  IMAGE: "image",
  LIST: "list",
  COLOR: "color",
} as const;

export const FIELD_NAME_SUFFIX = {
  TEXT: "text",
  URL: "url",
  IMAGE: "image",
  COLOR: "color",
} as const;

export const FIELD_INPUT_TYPES = FIELD_NAME_SUFFIX;

export const PREFIXES = {
  STATIC_KEY: "STATIC_KEY",
  DYNAMIC_KEY: "DYNAMIC_KEY",
  STYLE: "STYLE",
} as const;

export const DYNAMIC_KEYS = {
  COMPANY_LOGO: "c_logo",
  COMPANY_NAME: "c_name",
} as const;

export const CREATIVE_TEMPLATE_TYPES = {
  PERSONALIZED: "personalized",
  STANDARD: "standard",
} as const;

// These are indexed dynamically (`TEMPLATE_LIST_KEYS[key](queryParams)` in `useTemplateList`),
// so every member here has to keep taking the same query-params object.
export const TEMPLATE_LIST_KEYS = {
  default: () => ["templates"],
  withId: ({ id }: { id?: unknown }) => [...TEMPLATE_LIST_KEYS.default(), id],
  withType: ({ type = "all" }: { type?: unknown }) => [
    ...TEMPLATE_LIST_KEYS.default(),
    type,
  ],
};

export const TEMPLATE_KEYS = {
  default: () => ["template"],
  // Takes the id directly: its only call site (`useTemplate`) passes a bare id, so the previous
  // `({ id })` destructure always produced `["template", undefined]` — every template shared one
  // cache entry and the detail page painted the previously opened template while the next loaded.
  withId: (id?: number | string) => [...TEMPLATE_KEYS.default(), id],
};

export const TEMPLATE_FIELDS = {
  default: () => ["template", "fields"],
  // Spread `TEMPLATE_FIELDS.default()`, not `TEMPLATE_KEYS.default()` — the latter put these
  // under the single-template namespace. Latent: no call site today.
  withId: ({ id }: { id?: unknown }) => [...TEMPLATE_FIELDS.default(), id],
  withMappingId: ({ templateMappingId }: { templateMappingId?: unknown }) => [
    ...TEMPLATE_FIELDS.default(),
    "mapping",
    templateMappingId,
  ],
};
export const PERSONALIZED_VARIABLES = {
  COMPANY_NAME: "{{c_name}}",
  INDUSTRY: "{{c_industry}}",
} as const;

export const PERSONALIZED_VARIABLES_MANUAL_PERSONALIZED = {
  COMPANY_NAME: "{{company_name}}",
  INDUSTRY: "{{industry}}",
} as const;

export const REGEX_PERSONALIZED_VARIABLES_MANUAL_PERSONALIZED = new RegExp(
  /{{(company_name|industry)}}/g
);

export const AI_RESPONSE_TEXT_FIELDS = {
  HEADER_TEXT: "header_text",
  BODY_TEXT: "body_text",
  DESCRIPTION_TEXT: "description_text",
} as const;

export const DEPRECATED_TEXT_FIELD_MAP: Record<string, string> = {
  footer_text: "description_text",
} as const;

export const OPTIONAL_TEXT_FIELDS = ["cta_text"] as const;
